// This module adds Roboto font to jsPDF for proper Czech character support
// Font files will be loaded at runtime

export const addRobotoFont = async (doc: any) => {
  try {
    // Load Roboto Regular font
    const regularResponse = await fetch('/fonts/Roboto-Regular.ttf')
    const regularArrayBuffer = await regularResponse.arrayBuffer()
    const regularBase64 = btoa(
      new Uint8Array(regularArrayBuffer).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        '',
      ),
    )

    // Load Roboto Bold font
    const boldResponse = await fetch('/fonts/Roboto-Bold.ttf')
    const boldArrayBuffer = await boldResponse.arrayBuffer()
    const boldBase64 = btoa(
      new Uint8Array(boldArrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), ''),
    )

    // Add fonts to PDF
    doc.addFileToVFS('Roboto-Regular.ttf', regularBase64)
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal')

    doc.addFileToVFS('Roboto-Bold.ttf', boldBase64)
    doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold')

    // Set Roboto as default font
    doc.setFont('Roboto', 'normal')

    return true
  } catch (error) {
    console.error('Error loading Roboto font:', error)
    return false
  }
}
